import Swal from "sweetalert2";

export const ValidateText = (value, titulo, mensaje) => {
  var retorno = true;
  if (value === undefined) retorno = false;
  else if (value === null) retorno = false;
  else if (value === "") retorno = false;
  if (retorno === false) {
    Swal.fire(titulo, mensaje, "error");
  }
  return retorno;
};
